import { Check } from "lucide-react";
import { cn } from "@/utils/css";

export const Checkbox = ({ checked, onChange, label, disabled = false, className = "", labelClassName = "" }) => (
    <button
        type="button"
        onClick={() => !disabled && onChange(!checked)}
        disabled={disabled}
        aria-pressed={checked}
        className={cn(
            "flex items-center gap-2 px-[2px]",
            { "opacity-50 cursor-not-allowed": disabled },
            className,
        )}
    >
        <span
            className={cn(
                "flex items-center justify-center size-4 rounded-[2px] shrink-0 border",
                checked ? "bg-cm-p-accent-500 border-cm-p-accent-500" : "border-cm-p-accent-500",
            )}
        >
            {checked && <Check className="size-3 text-cm-p-surface" strokeWidth={3} />}
        </span>
        {label && (
            <span className={cn("text-[14px] font-medium text-cm-p-text-primary text-left", labelClassName)}>{label}</span>
        )}
    </button>
);
